<template>
  <el-dialog
    id="console-ssh"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="618px"
    top="40px"
  >
    <Xterm
      v-loading="!connected"
      element-loading-text="Connecting to application ..."
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :connected.sync="connected"
      :socket-query="query"
    />

    <div slot="title">
      <span v-if="connected" class="connected"><i class="el-icon-success" /> Connected</span>
      <span v-else><i class="el-icon-loading" /> Connecting</span>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import Xterm from './Xterm'

export default {
  props: {
    applicationId: String,
    open: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Xterm
  },
  data () {
    return {
      visible: this.open,
      connected: false
    }
  },
  computed: {
    query () {
      return `token=${this.token}&roleId=${this.roleId}&applicationId=${this.applicationId}`
    },
    ...mapState(['token', 'roleId'])
  },
  watch: {
    visible (value) {
      this.$emit('update:open', value)
    }
  }
}
</script>

<style lang="scss">
  @import "../../../theme";

  #console-ssh {
    .el-dialog__header {
      padding-top: 10px;

      .connected {
        color: $--color-success;
      }
      .el-dialog__headerbtn {
        top: 10px;
      }
    }

    .el-dialog__body {
      padding: 3px 0 3px 3px;
      background-color: #000;
    }
  }
</style>
